var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;

export { defaultOrdinal, defaultDayOfMonthOrdinalParse };

export function ordinal(number) {
    return this._ordinal.replace('%d', number);
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/ordinal.js
// module id = 271
// module chunks = 0